import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="py-8 text-center">
      <p className="small-text text-charcoal/60">
        Built with 💕 by Rich & Cat
      </p>
    </footer>
  );
};

export default Footer;